import { appError } from '@payaca/utilities/appError';
import { z } from 'zod/v4';

/**
 * Structural email validation shared across the client and server so the
 * front-end form check and the back-end send/resend guards can't drift.
 */
export const emailSchema = z.email();

/** Whether an address is a structurally valid email. */
export const isValidEmailAddress = (email: string): boolean =>
  emailSchema.safeParse(email).success;

/**
 * Throw if `email` is present but not a structurally valid email address.
 * An absent or empty value is permitted — the address is treated as optional.
 */
export const assertValidEmailAddress = (
  email: string | null | undefined
): void => {
  if (email?.length && !isValidEmailAddress(email)) {
    throw appError(
      'BUSINESS_VALIDATION_FAILED',
      `"${email}" is not a valid email address`
    );
  }
};
